import styled from 'styled-components';

export const StyledNav = styled.nav`
    padding: 12px 0 0;
    display: flex;
    margin: 0 auto;

    @media(max-width: 992px) {
        justify-content: space-between;
    }      
`